import { createFileRoute, redirect } from '@tanstack/react-router';
import { WaitlistPage } from '@/page/WaitlistPage';

/** Clerk's waitlist for a visitor without an invitation. An account already
 * has one and goes home. */
export const Route = createFileRoute('/waitlist')({
  beforeLoad: ({ context }) => {
    if (context.account()) throw redirect({ to: '/', replace: true });
  },
  component: WaitlistPage,
});
